export const CONFIG = {
  "PROJECTNAME": "enka",
  "COMPANYNAME": "Enka",
  "DFTLNGCODE": "nl",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10180001",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#5e0835",
    "primary100": "#F2CECC",
    "light": "#94b93e",
    "secondary": "#5e0835",
    "dark": "#5e0835",
    "siteColor3": "#fff",
    "menuSecondary": "#5e0835"
  }
};